import React,{useState} from 'react';
import AuthService from "../../../Services/auth/authAPI";
import {Link, useNavigate, useParams} from "react-router-dom";

const CashierSidebar = ({pathname}) => {

    const id = useParams();

    const navigate = useNavigate();
    const [me, setMe] = useState(AuthService.getAuthenticatedUser());

    const handleLogout = () => {
        AuthService.logout();
        navigate("/login")
    };

    return (
        <aside id="sidebar" className="sidebar">

            <ul className="sidebar-nav" id="sidebar-nav">

                <li className="nav-item">
                    <Link className={pathname === '/cashier/dashboard' ? 'nav-link ' : 'nav-link collapsed'} to="/cashier/dashboard">
                        <i className="bi bi-grid"></i>
                        <span>Tableau de bord</span>
                    </Link>
                </li>

                <li className="nav-heading">ACTIONS DE CAISSE</li>

                <li className="nav-item">
                    <Link className={pathname === '/cashier/cashIn' ? 'nav-link ' : 'nav-link collapsed'} to="/cashier/cashIn">
                        <i className="bi bi-arrow-right-square-fill"></i>
                        <span>Approvisionnement</span>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link className={pathname === '/cashier/cashOut' ? 'nav-link ' : 'nav-link collapsed'} to="/cashier/cashOut">
                        <i className="bi bi-arrow-left-square-fill"></i>
                        <span>Sortie caisse</span>
                    </Link>
                </li>

                <li className="nav-heading">RAPPORTS DE CAISSE</li>

                <li className="nav-item">
                    <Link className={pathname === '/cashier/rapport/cash/in' ? 'nav-link ' : 'nav-link collapsed'} to="/cashier/rapport/cash/in">
                        <i className="bi bi-clipboard2-pulse-fill"></i>
                        <span>Entrées caisse</span>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link className={pathname === '/cashier/rapport/cash/out/cdf' ? 'nav-link ' : 'nav-link collapsed'} to="/cashier/rapport/cash/out/cdf">
                        <i className="bi bi-clipboard-x-fill"></i>
                        <span>Sorties CDF</span>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link className={pathname === '/cashier/rapport/cash/out/usd' ? 'nav-link ' : 'nav-link collapsed'} to="/cashier/rapport/cash/out/usd">
                        <i className="bi bi-clipboard-x"></i>
                        <span>Sorties USD</span>
                    </Link>
                </li>

                <li className="nav-heading">PARAMETRAGE</li>

                <li className="nav-item">
                    <Link className={pathname === '/cashier/cashAccounts' ? 'nav-link ' : 'nav-link collapsed'} to="/cashier/cashAccounts">
                        <i className="bi bi-command"></i>
                        <span>Les comptes sources</span>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link className={pathname === '/cashier/comptes' ? 'nav-link ' : 'nav-link collapsed'} to="/cashier/comptes">
                        <i className="bi bi-compass"></i>
                        <span>Les comptes caisse</span>
                    </Link>
                </li>

            </ul>

            <div className="fixed-bottom mx-4 my-3">
                <button className="btn btn-danger" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-left"></i>
                    <span> Se deconnecter</span>
                </button>
            </div>

        </aside>
    );
};

export default CashierSidebar;